<script lang="ts">
	import { getEditor } from "luxedo-canvas"
	import { Responsive } from "responsive"
	import { SidebarController } from "./SidebarController.svelte"
	import { CollapsibleSectionNoBind } from "misc-ui"

	interface Props {
		selectedShape: string
	}

	let { selectedShape }: Props = $props()

	let expandHelp = $derived(SidebarController.showDetails)

	function onSave() {
		getEditor().mode.get().complete()
		getEditor().canvas.requestRenderAll()
		SidebarController.setView("default")
	}

	function cancel() {
		getEditor().mode.get().cancel()
	}
</script>

<CollapsibleSectionNoBind expanded={expandHelp} onclick={SidebarController.toggleDetails}>
	{#snippet header()}
		<div class="heading">
			<h3>Create new mask</h3>
			<button class="info-heading link-button small">{expandHelp ? "Hide" : "More"} details</button>
		</div>
	{/snippet}
	{#snippet content()}
		<p>
			{#if selectedShape === "freedraw"}
				{Responsive.isMobile ? "Tap" : "Click"} on the canvas to begin creating points which will create
				a mask. To automatically close the mask, {Responsive.isMobile ? "tap" : "click"} the "Complete"
				button below.
			{:else}
				{Responsive.isMobile ? "Tap" : "Click"} and drag on the canvas to create a {selectedShape} shaped
				mask.
			{/if}
		</p>
	{/snippet}
</CollapsibleSectionNoBind>
<hr />
<p class="info"></p>

<div class="button-container">
	<button class="outline-button warn" onclick={cancel}>Cancel</button>
	{#if selectedShape === "freedraw"}
		<button class="outline-button sidebar-button" onclick={onSave}>Complete</button>
	{/if}
</div>

<style>
	.button-container button {
		width: unset;
		flex-grow: 1;
	}

	p {
		color: var(--color-text);
		line-height: 1.2em;
	}
</style>
